/* eslint-disable react-hooks/exhaustive-deps */
import InputForm from "../../../components/inputs/InputForm";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Button, Col, Row } from "react-bootstrap";
import { Loader, toaster } from "rsuite";
import { useEffect, useState } from "react";
import InputSearch from "../../../components/inputs/InputSelectSearch";
import { Modulo } from "../../../types/admin-usuarios/Modulo";
import { swalAction } from "../../../components/Modals/ModalConfirm";
import peticionBack from "../../../libs/peticiones/peticionBack";
import { InputGroup } from "../../../components/inputs/InputGroup";
import { Sistema } from "../../../types/admin-usuarios/Sistema";
import InputSelectTree from "../../../components/inputs/InputSelectTree";
import createURL from "../../../libs/peticiones/url";
import { ModuloPermiso } from "../../../types/admin-usuarios/ModuloPermiso";
import { getMenu } from "../../../libs/menuPermissions/getMenu";
import { useStore } from "../../../context/AppContext";
import { Perfil } from "../../../types/admin-usuarios/Perfil";

const defaultForm: Modulo = {
    name: "",
    route: "",
    parent: "",
    level: 0,
    system: ""
};

const formSchema = Yup.object().shape({
    name: Yup.string().required("Ingrese un nombre para el módulo"),
    route: Yup.string().required("Ingrese la ruta para el módulo"),
    system: Yup.string().required("Seleccione un sistema"),
});


export default function Form({setOpen, selected} : {setOpen: any, selected?: Modulo}) {
    const [loading, setLoading] = useState<boolean>(true);
    const [modulos, setModulos] = useState<Modulo[]>([]);
    const [sistemas, setSistemas] = useState<Sistema[]>([]);
    const [planeModules, setPlaneModules] = useState<Modulo[]>([]);
	const { state, dispatch } = useStore();

    useEffect(()=>{
        getSistemas();
    }, []);
    
    function recursiveMap(modules: Array<Modulo>, plMod: Array<Modulo>, parent?: Modulo){
        modules.forEach((mod: any)=> {
            const cpPad = {...mod}
            if(mod.children){
                delete cpPad.children;
                recursiveMap(mod.children, plMod, cpPad);
            }
            plMod.push(cpPad);
        });
    }
    
    async function getSistemas(){
        const res = await peticionBack({}, "/sistemas", "GET", false, toaster);
        if(res) setSistemas(res.data);
        setLoading(false);
    }

    const {
        handleSubmit,
        handleReset,
        handleBlur,
        setFieldValue,
        setValues,
        values,
        errors,
        touched,
    } = useFormik({
        initialValues: defaultForm,
        validationSchema: formSchema,
        onSubmit: (values) => {
            swalAction(
                save, 
                `${selected? "Editar" : "Guardar"} Módulo`, 
                `¿Desea ${selected? "editar" : "guardar"} este módulo?`, 
                "question"
            )
        },
        onReset: () => {setOpen(false)},
    });

    function onChange({ target }: { target: any }) {
        if(target.name === "parent"){
            const parent = planeModules.find((m: Modulo) => m._id === target.value);
            if(parent){
                setFieldValue("level", parent.level + 1);
            }
        }
        if (target.name === "route" && target.value.includes("/")) return;
        if (target.name === "system"){
            if(!target.value) setModulos([]);
        }
        setFieldValue(target.name, target.value);
    }
    
    async function getModulos(){
        const url = createURL("/modulos", [
            {name: "system", value: values.system as string},
        ]);
        const res = await peticionBack({}, url, "GET", false, toaster);
        if(res){ 
            setModulos(res.data);
            const plnMod: Modulo[] = [];
            recursiveMap(res.data, plnMod);
            setPlaneModules(plnMod);
        }
        setLoading(false);
    }

    useEffect(()=>{
        if(selected){
            setValues({
                ...selected,
                route: selected.route.replace("/", ""),
                parent: (selected.parent as Modulo)?._id,
                system: selected.system ? (selected.system as Modulo)._id as string : "",

            }, true);
        }
    }, []);
    
    useEffect(()=>{
        if(values.system) getModulos();
    }, [values.system]);

    async function save(){
        const method = selected ? "PUT" : "POST";
        const rute = selected ? `/${selected._id}` : "";
        setLoading(true);
        const params = {
            ...values,
            route: "/"+values.route
        }
        if(!values.parent) delete params.parent;
        const res = await peticionBack(params, "/modulos" + rute, method, true, toaster);
        if(res){
            handleReset(null);
            if(state.menu.modulos?.find((m: ModuloPermiso)=> m._id === selected?._id)) {
                getMenu(dispatch, state.user.currentperfil as Perfil);
            }
        }
        setLoading(false);
    }

    return (
        <form onSubmit={handleSubmit} onReset={handleReset}>
            <Row>
                <Col xs={12} md={6}>
                    <InputForm
                        label="Nombre del módulo"
                        name="name"
                        type="text"
                        value={values.name}
                        touched={touched.name}
                        error={errors.name}
                        onChangeMethod={onChange}
                        onBlurMethod={handleBlur}
                        required
                    />
                </Col>
                <Col xs={12} md={6}>
                    <InputGroup
                        label="Ruta"
                        name="route"
                        type="text"
                        value={values.route}
                        touched={touched.route}
                        error={errors.route}
                        onChangeMethod={onChange}
                        onBlurMethod={handleBlur}
                        required
                        left={"/"}
                    />
                </Col>
                <Col xs={12} md={6}>
                    <InputSearch
                        label="Sistema"
                        name="system"
                        value={values.system as string}
                        touched={touched.system}
                        error={errors.system}
                        values={sistemas}
                        labelVal="name"
                        valueVal="_id"
                        onChangeMethod={onChange}
                        onBlurMethod={handleBlur}
                        required
                    />
                </Col>
                <Col xs={12} md={6}>
                    <InputSelectTree
                        label="Módulo padre"
                        name="parent"
                        value={values.parent as string || ""}
                        touched={touched.parent}
                        error={errors.parent}
                        values={modulos}
                        labelVal="name"
                        valueVal="_id"
                        onChangeMethod={onChange}
                        onBlurMethod={handleBlur}
                        disabled={!values.system && modulos.length < 1}
                        disabledItemValues={[selected?._id||""]}
                    />
                </Col>
            </Row>

            <div className="d-grid gap-2 d-md-flex justify-content-md-around mt-2">
                <Button variant="danger" type="reset">
                    Cancelar
                </Button>
                <Button variant="success" type="submit">
                    Guardar
                </Button>
            </div>

            { loading && <Loader backdrop vertical style={{zIndex: 5}} /> }
        </form>
    )
}
